import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Modal, message, Tag} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 120,
        label: '所属部门'
    },
    {
        key: 'className', width: 100,
        label: '所属班级'
    },
    {
        key: 'classGrade', width: 100,
        label: '所属年级'
    },
    {
        key: 'objectCode', width: 100,
        label: '学号'
    },
    {
        key: 'objectName', width: 85,
        label: '姓名'
    },
    {
        key: 'yearSystemName', width: 85,
        label: '学制'
    },{
        key: 'schoolYearName', width: 85,
        label: '学年'
    },
    {
        key: 'targetName', width: 120,
        label: '模块名称',
    },
    {
        key: 'resultScore', width: 100,
        label: '录入积分',
    },
    {
        key: 'auditScore', width: 90,
        label: '审核积分',
    },
    // {
    //     key: 'submitEmployeeName', width: 70,
    //     label: '录入人'
    // },
    
    {key:'schoolAudit', label: '状态', width: 85, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>未知状态</Tag>)},
    {
        key:'importObject', 
        label: '数据来源',
        width: 85,
        render:(d) => {
            if (+d === 1) {
                return <Tag>班级组导入</Tag>
            } else if (+d === 2) {
                return <Tag>院级导入</Tag>
            } else if (+d === 3) {
                return <Tag>校级导入</Tag>
            } else if (+d === 4) {
                return <Tag>扫码参与</Tag>
            } else if (+d === 5) {
                return <Tag>报名参与</Tag>
            } else {
               return <Tag>学生申报</Tag>
            }
        }},
    // {
    //     key: 'termName', width: 120,
    //     label: '所属学期'
    // },
    {
        key: 'endYearName',
        label: '结束学年'
    },
    {
        key: 'yearName', width: 120,
        label: '所属学年'
    },
    {key:'createTime', label: '创建日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('second/credit/school/auditresult/query?'+ params.join('&'), newKeyword)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('second/credit/school/auditresult/get/'+ id, {})
    .then(response => {
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('second/credit/school/auditresult/remove', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                callback();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'jszgsubresult'+ url;
};

/**
 * @method batchBack
 * @return {promise}
 */
 const batchBack = (callback) => {
    return fetch.post('second/credit/school/auditresult/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

/**
 * @method batchSubmit
 * @return {promise}
 */
 const batchSubmit = (callback) => {
    return fetch.post('second/credit/school/auditresult/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
        callback();
    });
}

const auditInsert = (domain) => {
    return fetch.post('second/credit/school/auditresult/insert' , domain)
    .then(response =>{
        return response
    })
}

export default {
    querySearch,
    querySearchById,
    batchBack,
    download: fetch.base + 'second/credit/enter/file/download?id=',
    remove,
    headers,
    onSelect,
    batchSubmit,
    auditInsert,
    batchRemove,
    setRefresh,
    redirect,
    getSelection,
}
